import { TooltipProps } from "recharts";
import "./styles/CustomTooltip.scss"
import { formatNumber } from "./formatValue";
import i18next from "i18next";

interface ITooltipProps extends TooltipProps<number, string> {
	type: "time" | "cost"
}

const CustomTooltip: React.FC<ITooltipProps> = ({ active, payload, label, type }) => {
	if (!active || !payload || !payload.length) return null;

	const { t } = i18next;

	return (
		<div className="chart-tooltip" style={{"--color": payload[0].payload.color} as React.CSSProperties}>
			<div className="chart-tooltip__name">{label}</div>
			<div className="chart-tooltip__value">
				{payload.map((entry, index) => (
					<p key={index}>
						<span>{entry.name}</span> <span>{formatNumber(Number(entry.value), 2)}% - {formatNumber(entry.payload.value, type === "time" ? 1 : 2)} {type === "time" ? t("analytics_page.pie.h") : "₴"}</span>
					</p>
				))}
			</div>
		</div>
	);
};

export default CustomTooltip;